import { SkuType } from '@ydistri/api-sdk';

export const getValidSkuType = (st: SkuType | null | undefined): SkuType => st ?? SkuType.FastMover;
